module.exports = __webpack_public_path__ + "img/bhi_logo.865c22a4.png";